import { sdk } from 'src/utilities/sdk';
import { IDepartment } from 'src/utilities/useSearchHooks';

export const getDepartmentUrl = (
  corpId: string,
  departmentId: string
): string => `/corp-admin/${corpId}/departments/${departmentId}`;

export const getDepartment = async (
  corpId: string,
  departmentId: string
): Promise<IDepartment> => {
  return sdk.http.get(getDepartmentUrl(corpId, departmentId));
};
